import React from 'react';
import { render } from '@testing-library/react';

// Jest has no transform for image imports; stub the checkmark asset.
jest.mock(
  '../../../../../assets/images/checkmark.png',
  () => 'checkmark.png',
);

// eslint-disable-next-line import/first
import WelcomeScreen from './WelcomeScreen';

const translations = {
  channelEmail: 'email',
  channelMobile: 'mobile phone number',
  accountAssociatedHtml:
    'Your account was successfully associated with <strong>Acme Portal</strong>.',
  channelAdded: 'Your %{channel} was successfully added to your account.',
  channelUpdates:
    'You will now start receiving updates through text messages on your %{channel}.',
  goToCase: 'GO TO CASE',
  noCommunications: 'There are no communications available yet.',
  reviewNotificationPreferences: 'REVIEW MY NOTIFICATION PREFERENCES',
};

describe('WelcomeScreen', () => {
  it('interpolates the channel noun into the localized success copy', () => {
    const { getByText } = render(
      <WelcomeScreen
        requestType="email"
        onContinue={() => {}}
        translations={translations}
      />,
    );

    expect(
      getByText('Your email was successfully added to your account.'),
    ).toBeInTheDocument();
    expect(getByText('GO TO CASE')).toBeInTheDocument();
  });

  it('renders the server-interpolated account-associated HTML when no request is needed', () => {
    const { container, getByText } = render(
      <WelcomeScreen requestType="ok" translations={translations} />,
    );

    expect(container.querySelector('strong')).toHaveTextContent('Acme Portal');
    expect(getByText('There are no communications available yet.')).toBeInTheDocument();
  });
});
